<template>
  <div class="two-to-three">
    <div class="header" style="margin-top: .04rem;">
      <div>{{floorData.floorTitle}}</div>
      <a v-if="floorData.isMore === '0'" class="more" :href="!$isIframe ? floorData.moreUrl: 'javascript:void(0);'">
        <span>更多</span>
        <img src="@/assets/img/arrow-right.png" />
      </a>
    </div>
    <div class="content">
        <div class="one-pic">
            <a @click="$jumpToPage(floorData.data[0])">
                <img class="first" :src="floorData.data[0].imageUrl" />
            </a>
            <a @click="$jumpToPage(floorData.data[1])">
                <img class="second" :src="floorData.data[1].imageUrl" />
            </a>
        </div>
        <div v-if="threeGrids.length > 0" class="three-pics">
            <div v-for="(item, idx) in threeGrids" :key="idx" class="box-item">
                <a @click='$jumpToPage(item)' >
                    <img class="item-img" :src="item.imageUrl" />
                </a>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TwoToThree',
  props: ['floorData'],
  computed: {
    threeGrids () {
      return this.floorData.data.length > 0 ? this.floorData.data.slice(2) : []
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .two-to-three{
    padding: 0 0.1rem;
    .content{
        overflow: hidden;
        .one-pic{
            height: 1.13rem;
            width: 100%;
            display: flex;
            justify-content: space-between;
            a{
                height: 100%;
                // width: 100%;
                // display: flex;
                // justify-content: space-between;
                img{
                    height: 100%;
                    border-radius: 5px;
                }
                .first{
                    width: 2.34rem;
                }
                .second{
                    width: 1.13rem;
                }
            }
        }
        .three-pics{
            margin-top: .08rem;
            display: flex;
            // justify-content: space-between;
            .box-item{
                width: 1.13rem;
                height: 1.13rem;
                margin-right: .08rem;
                .item-img{
                    width: 100%;
                    height: 100%;
                    border-radius: 5px;
                }
            }
            .box-item:last-child{
              margin-right: 0;
            }
        }
    }
  }
</style>
